import { z } from 'zod'
import type { TwoFactorAdminStatus } from '../../models/TwoFactorAdminStatus'
import { TwoFactorMethod } from '~/domain/shared/two-factor/models/TwoFactorMethod'

export const TwoFactorAdminStatusDTO = z.object({
  enabled: z.boolean(),
  method: z.nativeEnum(TwoFactorMethod).nullish(),
  version: z.number().int().min(1).nullish()
})

export type TwoFactorAdminStatusDTO = z.infer<typeof TwoFactorAdminStatusDTO>

export function mapDTOToTwoFactorAdminStatus (dto: TwoFactorAdminStatusDTO): TwoFactorAdminStatus {
  return {
    enabled: dto.enabled,
    method: dto.method ?? undefined,
    version: dto.version ?? undefined
  }
}

export function mapTwoFactorAdminStatusToDTO (model: TwoFactorAdminStatus): TwoFactorAdminStatusDTO {
  return {
    enabled: model.enabled,
    method: model.method ?? null,
    version: model.version ?? null
  }
}
